import { TranscriptionContext } from "@context/TranscriptionContext";
import { mintRoomWsToken } from "@transcription/dev/fixturesClient";
import { useLabRoomStore } from "@transcription/dev/labRoomStore";
import {
  useLiveTranscription,
  type StartOptions,
} from "@transcription/use-live-transcription";
import { devToolsEnabled } from "@utils/devTools";
import type { ReactNode } from "react";

/**
 * One live-transcription controller at the router root, so navigation keeps the
 * socket and recording alive. Audio anchors to the clinic (or lab room);
 * patient/visit attribution is the agent's job, never UI state.
 */
export const TranscriptionProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const labRoom = useLabRoomStore((s) => s.room);
  const transcription = useLiveTranscription();

  // Dev-only: a lab room makes every stream present as that room's Zuul device.
  const roomMode = devToolsEnabled() && labRoom ? labRoom : null;
  const start = (options?: StartOptions) =>
    transcription.start({
      ...options,
      wsToken:
        options?.wsToken ??
        (roomMode ? () => mintRoomWsToken(roomMode.id) : undefined),
      roomUuid: options?.roomUuid ?? roomMode?.id,
    });

  return (
    <TranscriptionContext.Provider value={{ ...transcription, start }}>
      {children}
    </TranscriptionContext.Provider>
  );
};
